
import Navigation from './Navagation'
export default {
  components: {
    Navigation
  },
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    CloseNavigation (value) {
      this.drawer = value
    },
    OpenNavigation () {
      this.drawer = true
      this.$refs.Navigation.SetLine()
    }
  }
}
